<template>
  <div v-if="visible.length"
       class="cu-sync">
    <div class="cu-sync-head">
      <b>{{ $t("broadcast.customers.sync_title") }}</b>
      <span class="cu-fresh"><i class="cu-dot"></i><span class="cu-mono">{{ $t("broadcast.customers.fresh", { n: ageSeconds }) }}</span></span>
    </div>
    <BcProgress v-for="item in visible"
                :key="item.pageId"
                :name="nameOf(item.pageId)"
                :item="item" />
    <p v-if="more"
       class="cu-more"><small>{{ $t("broadcast.customers.more_pages", { n: more.toLocaleString("en-US") }) }}</small></p>
  </div>
</template>

<script>
import BcProgress from "@/components/derived/broadcast/BcProgress";

// The "ดึงแชทย้อนหลัง 30 วัน" card. `sync` is sync[] of GET /api/broadcast/customers/summary, `names` maps
// pageId to the Page's name. Shows the Pages still reading (state syncing): queued first, then the longest
// ETA, at most 3, then "และอีก N เพจ". Hidden when none is left.
export default {
  name: "CustomerSyncCard",
  components: { BcProgress },
  props: {
    sync: { type: Array, default: () => [] },
    names: { type: Object, default: () => ({}) },
    ageSeconds: { type: Number, default: 0 },
  },
  computed: {
    unfinished() {
      const left = (it) => (it.etaSeconds != null ? it.etaSeconds : -1);
      return this.sync
        .filter((it) => it.state === "syncing")
        .sort((a, b) => {
          const qa = a.queuePosition != null;
          const qb = b.queuePosition != null;
          if (qa !== qb) return qa ? -1 : 1;
          if (qa) return a.queuePosition - b.queuePosition;
          return left(b) - left(a);
        });
    },
    visible() {
      return this.unfinished.slice(0, 3);
    },
    more() {
      return Math.max(0, this.unfinished.length - 3);
    },
  },
  methods: {
    nameOf(pageId) {
      return this.names[pageId] || String(pageId);
    },
  },
};
</script>

<style lang="scss" scoped>
.cu-sync {
  background: #f3f3f3;
  border-radius: 10px;
  padding: 0.75rem 1rem;
  margin-bottom: 1rem;
}

.cu-sync-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.5rem;
  flex-wrap: wrap;
  margin-bottom: 0.75rem;
  color: #333;
}

.cu-mono {
  font-family: SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
  font-variant-numeric: tabular-nums;
}

.cu-fresh {
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
  padding: 0.15rem 0.6rem;
  border-radius: 999px;
  background: #fff;
  border: 1px solid #e0e0e0;
  font-size: 0.75rem;
  color: #555;
}

.cu-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #d98a00;
  animation: cu-dot-pulse 1.2s ease-in-out infinite;
}

.cu-more {
  margin: 0.25rem 0 0;
  color: #666;
}

@keyframes cu-dot-pulse {
  0%,
  100% {
    opacity: 1;
  }
  50% {
    opacity: 0.35;
  }
}

@media (prefers-reduced-motion: reduce) {
  .cu-dot {
    animation: none;
  }
}

body.--dark {
  .cu-sync {
    background: #4b4b4b;
  }

  .cu-sync-head {
    color: #e6e6e6;
  }

  .cu-fresh {
    background: #373737;
    border-color: #666;
    color: #c4c4c4;
  }

  .cu-dot {
    background: #ffd98a;
  }

  .cu-more {
    color: #c4c4c4;
  }
}
</style>

